import React from "react";
import { AssetsProvider } from "../../store/AssetsProvider";
import AssetWrapper from "./components/AssetWrapper";
import "./core/styles.scss";

export default function AssetsPage() {
  return (
    <AssetsProvider>
      <AssetWrapper />
    </AssetsProvider>
  );
}
